// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bah1h6o{justify-content:center}\n._1bsb7vkz{width:1pc}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._4t3i7vkz{height:1pc}\n._4t3igktf{height:20px}", ""]);
// Exports
module.exports = exports;
